<div class="container-fluid">
  <div class="card">
    <div class="card-header nocollapse">
      Question Language Settings
    </div>
  </div>
  <div class="d-flex" style="justify-content: space-between;">
    <div class="page-attributes p-1">
    </div>
    <div class="p-1">
      <button type="button" class="btn btn-primary btn-action" (click)="backUrl()"><i class="fa fa-home"></i> Home</button>
    </div>
  </div>
  <div style="padding:0 11px" [hidden]="folderId == -1">
    <div class="bg-info p-1">
      <span><b>Folder Name : </b>{{ folderName }}</span>
    </div>
  </div>
  <div id="messageContainer" class="card-header nocollapse bg-info col-md-12 msg-container" style="display:none;">
    <i class="fa fa-info-circle fa-lg mt-1" style="color: #326295;"></i>
    <span id="message"></span>
  </div>

  <div class="card-body">
    <form [formGroup]="questionLanguageForm" class="col-md-12">
      <accordion class="nav-item dropdown p-2">
        <accordion-group [isOpen]=true>
          <small class="form-text text-muted invalid-control-message" *ngIf="!questionLanguageForm.valid && questionLanguageForm.touched">
            Please Enter Required Fields.
          </small>
          <span accordion-heading>
            Question Language
          </span>
          <div class="row">
            <label class="form-control-label col-md-2" for="description">Original Question Text</label>
            <label class="form-control-label col-md-8" for="description">{{question.text}}</label>
            <!--<div class="form-control-sm col-md-2">
              <label class="form-control-label" for="description">{{question.text}}</label>
            </div>-->
          </div>

          <div class="row">
            <label class="form-control-label col-md-2" for="questionLanguageId">Preferred Language</label>
            <select name="questionLanguageId" id="questionLanguageId" formControlName="questionLanguageId" style="margin-left:14px;" class="form-control-sm col-md-2">
              <option value="" selected>--Select--</option>
              <option *ngFor="let item of languageList" [ngValue]="item?.languageId" [selected]="questionLanguageId==item?.languageId">
                {{item.languageName}}
              </option>
            </select>
          </div>
          <div class="row">
            <label class="col-md-2 form-control-label" for="questionLanguageText">Question Text In Language</label>
            <input class="col-md-2 form-control-sm" style="margin-left:14px;" maxlength="1000" type="text" id="questionLanguageText" name="questionLanguageText" formControlName="questionLanguageText" placeholder="Question Language Text" />
          </div>

          <button (click)="saveQuestionLanguage()" type="button" class="btn btn-primary btn-action pull-right" [disabled]="this.questionLanguageForm.value.questionLanguageId==='' || this.questionLanguageForm.value.questionLanguageText.trim()===''"><i class="fa fa-plus"></i> Create / Update</button>
          <button type="button" class="btn btn-secondary btn-action pull-right" (click)="resetQuestionLanguage()"><i class="fa fa-eraser"></i> Clear</button>
        </accordion-group>

        <accordion-group [isOpen]=true *ngIf="question.type === 'MultipleResponse' || question.type === 'MultipleChoice' || question.type === 'Picklist' || question.type === 'RankingSort' || question.type === 'Slider'">
          <span accordion-heading>
            Option Configuration
          </span>

          <div class="row col-md-12">
            <button type="button" class="btn btn-secondary btn-action" (click)="resetOptionLanguage()"><i class="fa fa-eraser"></i> Clear</button>
            <button (click)="saveOptionLanguage()" type="button" class="btn btn-primary btn-action" [disabled]="this.questionLanguageForm.value.optionId==='' || this.questionLanguageForm.value.optionLanguageId==='' || this.questionLanguageForm.value.optionLanguageText.trim()===''"><i class="fa fa-plus"></i> Create / Update</button>
          </div>

          <div class="form-group row p-2">
            <label class="col-md-2 form-control-label" for="optionId">Option Name</label>
            <select *ngIf="question.type === 'MultipleResponse' || question.type === 'MultipleChoice' || question.type === 'RankingSort'" name="optionId" id="optionId" formControlName="optionId" style="margin-left:14px;" class="form-control-sm col-md-2">
              <option value="" selected>--Select--</option>
              <option *ngFor="let item of questionOptionsList" [ngValue]="item?.optionId" [selected]="optionId==item?.optionId">
                {{item.name}}
              </option>
            </select>
            <select *ngIf="question.type === 'Picklist'" name="optionId" id="optionId" formControlName="optionId" style="margin-left:14px;" class="form-control-sm col-md-2">
              <option value="" selected>--Select--</option>
              <option *ngFor="let item of questionOptionsList" [ngValue]="item?.value" [selected]="optionId==item?.value">
                {{item.text}}
              </option>
            </select>
            <select *ngIf="question.type === 'Slider'" name="optionId" id="optionId" formControlName="optionId" style="margin-left:14px;" class="form-control-sm col-md-2">
              <option value="" selected>--Select--</option>
              <option *ngFor="let item of questionOptionsList" [ngValue]="item?.rangeId" [selected]="optionId==item?.rangeId">
                {{item.rangeDescription}}
              </option>
            </select>

            <label class="col-md-2 form-control-label" for="optionLanguageId">Preferred Language</label>
            <select name="optionLanguageId" id="optionLanguageId" formControlName="optionLanguageId" style="margin-left:14px;" class="form-control-sm col-md-2">
              <option value="" selected>--Select--</option>
              <option *ngFor="let item of languageList" [ngValue]="item?.languageId" [selected]="optionLanguageId==item?.languageId">
                {{item.languageName}}
              </option>
            </select>

            <label class="col-md-1 form-control-label" style="margin-left:14px;" for="optionLanguageText">Option Language Text</label>
            <input class="col-md-2 form-control-sm ml-1" maxlength="100" type="text" id="optionLanguageText" name="optionLanguageText" formControlName="optionLanguageText" placeholder="Option Language Text" />

            <div class="row col-md-12">

            </div>
          </div>

        </accordion-group>


        <accordion-group [isOpen]=true *ngIf="question.type === 'Matrix'">
          <span accordion-heading>
            Column Item Configuration
          </span>

          <div class="row col-md-12">
            <button type="button" class="btn btn-secondary btn-action" (click)="resetColumnItemLanguage()"><i class="fa fa-eraser"></i> Clear</button>
            <button (click)="saveColumnItemLanguage()" type="button" class="btn btn-primary btn-action" [disabled]="this.questionLanguageForm.value.columnItemId==='' || this.questionLanguageForm.value.columnHeaderItemId==='' || this.questionLanguageForm.value.columnItemLanguageText.trim()===''"><i class="fa fa-plus"></i> Create / Update</button>
          </div>

          <div class="form-group row p-2">
            <label class="col-md-2 form-control-label" for="columnItemId">Column Item Name</label>
            <select name="columnItemId" id="columnItemId" formControlName="columnItemId" style="margin-left:14px;" class="form-control-sm col-md-2">
              <option value="" selected>--Select--</option>
              <option *ngFor="let item of columnItemList" [ngValue]="item?.columnItemId" [selected]="columnItemId==item?.columnItemId">
                {{item.columnHeaderText}}
              </option>
            </select>

            <label class="col-md-2 form-control-label" for="columnItemLanguageId">Preferred Language</label>
            <select name="columnItemLanguageId" id="columnItemLanguageId" formControlName="columnItemLanguageId" style="margin-left:14px;" class="form-control-sm col-md-2">
              <option value="" selected>--Select--</option>
              <option *ngFor="let item of languageList" [ngValue]="item?.languageId" [selected]="columnItemLanguageId==item?.languageId">
                {{item.languageName}}
              </option>
            </select>

            <label class="col-md-1 form-control-label" style="margin-left:14px;" for="columnItemLanguageText">Column Item Language Text</label>
            <input class="col-md-2 form-control-sm ml-1" maxlength="100" type="text" id="columnItemLanguageText" name="columnItemLanguageText" formControlName="columnItemLanguageText" placeholder="Column Item Language Text" />

            <div class="row col-md-12">

            </div>
          </div>
        </accordion-group>


        <accordion-group [isOpen]=true *ngIf="question.type === 'Matrix'">
          <span accordion-heading>
            Row Item Configuration
          </span>

          <div class="row col-md-12">
            <button type="button" class="btn btn-secondary btn-action" (click)="resetRowItemLanguage()"><i class="fa fa-eraser"></i> Clear</button>
            <button (click)="saveRowItemLanguage()" type="button" class="btn btn-primary btn-action" [disabled]="this.questionLanguageForm.value.rowItemId==='' || this.questionLanguageForm.value.rowItemId==='' || this.questionLanguageForm.value.rowItemLanguageText.trim()===''"><i class="fa fa-plus"></i> Create / Update</button>
          </div>

          <div class="form-group row p-2">
            <label class="col-md-2 form-control-label" for="rowItemId">Row Item Name</label>
            <select name="rowItemId" id="rowItemId" formControlName="rowItemId" style="margin-left:14px;" class="form-control-sm col-md-2">
              <option value="" selected>--Select--</option>
              <option *ngFor="let item of rowItemList" [ngValue]="item?.rowItemId">
                {{item.rowText}}
              </option>
            </select>

            <label class="col-md-2 form-control-label" for="rowItemLanguageId">Preferred Language</label>
            <select name="rowItemLanguageId" id="rowItemLanguageId" formControlName="rowItemLanguageId" style="margin-left:14px;" class="form-control-sm col-md-2">
              <option value="" selected>--Select--</option>
              <option *ngFor="let item of languageList" [ngValue]="item?.languageId">
                {{item.languageName}}
              </option>
            </select>

            <label class="col-md-1 form-control-label" style="margin-left:14px;" for="rowItemLanguageText">Row Item Language Text</label>
            <input class="col-md-2 form-control-sm ml-1" maxlength="100" type="text" id="rowItemLanguageText" name="rowItemLanguageText" formControlName="rowItemLanguageText" placeholder="Row Item Language Text" />

            <div class="row col-md-12">

            </div>
          </div>
        </accordion-group>

      </accordion>

    </form>

    <isg-grid
      [rowData]="questionOptionsLanguageMappedList"
      [columnDefs]="columnDefs"
      [config]="languageGridConfig"
      (gridReady)="onGridReady($event)"
      (rowSelected)="onRowChecked($event)">
    </isg-grid>
    <ng-template #deleteModelConfirmation let-modal>
      <div class="modal-header">
        <h5 class="modal-title">Delete confirmation</h5>
        <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
      </div>
      <div class="modal-body">
        <p>Are you sure you want to delete this mapping?</p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary btn-modal" (click)="modal.dismiss()"><i class="fa fa-times"></i> Close</button>
        <button type="button" class="btn btn-danger btn-modal" (click)="deleteMapping(); modal.close()"><i class="fa fa-trash"></i> Delete</button>
      </div>
    </ng-template>
  </div>
</div>




